import { YMapLocationRequest } from '@yandex/ymaps3-types';
import React from 'react';
import ReactDom from 'react-dom';

export const DEFAULT_LOCATION: YMapLocationRequest = {
  center: [37.613997, 55.756736],
  zoom: 5,
  easing: 'ease-in-out',
  duration: 1000
}

async function loadYandexMaps() {
  try {
    const [ymaps3React] = await Promise.all([
      ymaps3.import('@yandex/ymaps3-reactify'),
      ymaps3.ready
    ]);
    
    return ymaps3React;
  } catch (error) {
    console.error('Failed to load Yandex Maps:', error);
    return null;
  }
}

export const getYmaps3React = await loadYandexMaps;

export const getReactify = async (ymaps3React: any) => {
  const reactify = ymaps3React.reactify.bindTo(React, ReactDom);
  
  const reactifyModule = reactify.module(ymaps3);
  const {
    YMap,
    YMapDefaultSchemeLayer,
    YMapDefaultFeaturesLayer,
    YMapMarker,
    YMapFeature,
    YMapListener,
    geolocation,
    YMapControls,
    YMapDefaultSatelliteLayer,
    YMapLayer
  } = reactifyModule;
  
  const {YMapClusterer, clusterByGrid} = reactify.module(await ymaps3.import('@yandex/ymaps3-clusterer@0.0.1'));
  const {YMapGeolocationControl, YMapZoomControl} = reactify.module(await ymaps3.import('@yandex/ymaps3-controls@0.0.1'));
  
  return {
    reactify,
    reactifyModule,
    YMap,
    YMapDefaultSchemeLayer,
    YMapDefaultFeaturesLayer,
    YMapMarker,
    YMapFeature,
    YMapListener,
    geolocation,
    YMapControls,
    YMapDefaultSatelliteLayer,
    YMapLayer,
    YMapClusterer, clusterByGrid,
    YMapGeolocationControl, YMapZoomControl,
  }
}
